<template>
	<div
		class="!my-4"
		:data-pp-amount="ppAmount"
		:data-pp-countryCode="countryCode"
		data-pp-message
		data-pp-placement="product"
		data-pp-style-layout="text"
		data-pp-style-text-color="monochrome"
		data-pp-style-text-size="12"
		data-pp-style-text-align="left"
		data-pp-style-logo-type="inline"
		data-pp-style-logo-position="left"
	></div>
</template>
<script setup>
import { onMounted, computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useProductStore, useSessionStore } from '@stores'

const CLIENT_ID = import.meta.env.VITE_PAYPAL_CLIENT_ID

const props = defineProps({
	amount: {
		type: [Number, String],
		default: 0,
	},
	countryCode: {
		type: String,
		default: '',
	},
	currencyCode: {
		type: String,
		default: '',
	},
	useStore: {
		type: Boolean,
		default: false,
	},
})

const store = useProductStore()
const { selectedVariant } = storeToRefs(store)
const { currency_code, country_code } = storeToRefs(useSessionStore())

const currencyCode = computed(() => props.currencyCode ?? currency_code)
const countryCode = computed(() => props.countryCode ?? country_code)

onMounted(() => {
	// PayPal Pay Later - US only for now
	if (!document.getElementById('bt-sdk') && currencyCode.value.toLowerCase() === 'usd') {
		const btScript = document.createElement('script')
		const currency = currencyCode.value.toUpperCase()
		btScript.setAttribute('id', 'bt-sdk')
		btScript.setAttribute(
			'src',
			`https://www.paypal.com/sdk/js?client-id=${CLIENT_ID}&currency=${currency}&components=messages`
		)
		document.head.appendChild(btScript)
	}
})

const ppAmount = computed(() => (props.useStore ? selectedVariant.value?.priceRaw : parseInt(props.amount)))
</script>
